import React, { Component } from "react";
import "./PromoMaterials.css";
import { PromoMaterialsItem } from "./PromoMaterialsItem";
import SimpleSlider from "../SimpleSlider/SimpleSlider";
import { getImgUrl, limitText } from "../../Utility/Utility";
import { PromoMaterialsData } from "../../Data/Data";

class PromoMaterials extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();

    this.PromoMaterialsSliderSettings = {
      dots: false,
      infinite: true,
      cssEase: "linear",
      autoplay: false,
      lazyLoad: "ondemand",
      arrows: false,
      slidesToShow: this.props.items != undefined ? this.props.items : 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    };
  }

  render() {
    const data = [...PromoMaterialsData];
    const postsHtml = data.map((o, i) => {
      if (this.props.category == o.category) {
        return (
          <PromoMaterialsItem
            image={o.image}
            href={o.href}
            imageHover={o.imageHover}
            text={o.text}
            id={i}
            key={i}
            category={o.category}
          />
        );
      }
      // console.log("o:", o);
    });
    return (
      <div className={`wrapper-promomaterials ${this.props.category}`}>
        {/*<SimpleSlider settings={this.WebinarsSliderSettings}>{postsHtml}</SimpleSlider>*/}

        {postsHtml}
      </div>
    );
  }
}

export default PromoMaterials;



// WEBPACK FOOTER //
// ./src/Components/PromoMaterials/PromoMaterials.js